
/**
 * Constants for application saving functionality
 */

/**
 * Delay in milliseconds before triggering autosave
 */
export const AUTOSAVE_DELAY = 2000;

/**
 * List of valid fields that can be saved to the database
 */
export const VALID_FIELDS = [
  // Basic information
  'id',
  'user_id',
  'status',
  'progress',
  'first_name',
  'last_name',
  'title',
  'phone',
  'email',
  'company_legal_name',
  'company_dba',
  'address_line',
  'city',
  'state',
  'postal_code',
  'company_website',
  'corporate_structure',
  'ein',
  'primary_industry',
  
  // Company information
  'current_peo',
  'current_provider',
  'current_provider_other',
  'year_founded',
  'business_activities',
  'naics_code',
  'naics_description',
  'states_of_operation',
  'states_with_employees',
  'is_non_profit',
  'tax_exempt_status_file',
  
  // Employee information
  'w2_employee_count',
  'exempt_employee_count',
  'non_exempt_employee_count',
  'k1_count',
  'total_1099_count',
  'is_seasonal',
  'peak_w2_employee_count',
  'non_peak_w2_employee_count',
  'peak_exempt_employee_count',
  'peak_non_exempt_employee_count',
  'non_peak_exempt_employee_count',
  'non_peak_non_exempt_employee_count',
  'annual_volunteer_count',
  'estimated_annual_payroll',
  
  // Insurance details
  'current_medical_carrier',
  'desired_medical_carriers',
  'next_medical_renewal',
  'current_workers_comp_carrier',
  'workers_comp_renewal_date',
  'current_ancillary_carrier',
  'desired_ancillary_carriers',
  'health_plans',
  'employees_enrolled_in_health_plan',
  'employee_only_count',
  'employee_spouse_count',
  'employee_children_count',
  'employee_family_count',
  'active_pregnancies_count',
  'has_high_cost_claims',
  'high_cost_claims_details',
  'medical_with_peo',
  'workers_comp_with_peo',
  'ancillary_with_peo',
  'is_self_funded',
  'is_workers_comp_trust',
  
  // Medical questionnaire
  'has_kidney_disease',
  'has_diabetes',
  'has_liver_disease',
  'has_neural_disorder',
  'has_cardiovascular',
  'has_respiratory_disease',
  'has_musculoskeletal',
  'has_transplants',
  'has_cancer',
  'has_hiv_aids',
  'has_mental_health',
  'has_nervous_system',
  'has_premature_birth',
  'has_other_conditions',
  'other_conditions_details',
  
  // PEO integration options
  'peo_medical_insurance',
  'peo_workers_comp',
  'open_to_peo_benefits',
  'open_to_peo_workers_comp',
  'open_to_peo_401k',
  'open_to_peo_epli',
  'open_to_peo_ancillary',
  'open_to_peo_eap',
  
  // Workers comp assessment fields
  'wc_coverage_cancelled',
  'wc_cancellation_reason',
  'company_services_description',
  'physical_operations_description',
  'has_physical_stock',
  'provides_engineering_services',
  'has_usl_jones_exposure',
  
  // EPLI related fields
  'has_epli_insurance',
  'epli_insurance_details',
  'has_standalone_epli_policy',
  'layoff_percentage',
  'layoff_releases_percentage',
  'planned_layoffs_details',
  
  // Operational details
  'has_safety_program',
  'safety_program_details',
  'required_integrations',
  'has_over_road_trucking',
  'has_cannabis_hemp_contact',
  'cannabis_hemp_details',
  'has_elevated_workplace_risk',
  'workplace_risk_details',
  'has_company_aircraft',
  'has_marine_operations',
  'has_heavy_machinery',
  'has_recent_wc_claims',
  'has_foreign_travel',
  'foreign_travel_countries',
  'foreign_travel_frequency',
  'annual_foreign_trips',
  'avg_trip_duration',
  'max_employees_per_trip',
  'foreign_work_description',
  'has_international_employees',
  'international_employee_count',
  'international_employee_countries',
  'foreign_employees_citizenship',
  'will_hire_foreign_nationals',
  'has_unionized_employees',
  'union_names',
  'union_percentage',
  'has_government_contracts',
  'government_contracts_details',
  'has_hazardous_materials',
  'hazardous_materials_details',
  'has_independent_contractors',
  'independent_contractors_details',
  'has_subcontractors',
  'subcontractor_annual_cost',
  'subcontractor_percentage',
  'subcontractor_verification',
  'has_ocip_jobs',
  'ocip_jobs_details',
  'has_vehicle_exposure',
  'vehicle_count',
  'driver_count',
  'vehicle_safety_program',
  'has_heights_work',
  'heights_work_details',
  'max_height',
  'heights_safety_measures',
  'has_below_ground_work',
  'below_ground_work_details',
  'max_depth',
  'confined_space_procedures',
  'has_retirement_plan',
  'has_business_insurance',
  'business_insurance_provider',
  'business_insurance_renewal',
  'has_disability_insurance',
  'disability_insurance_provider',
  'disability_insurance_renewal',
  'has_recent_layoffs',
  'recent_layoffs_details',
  'layoff_count',
  'layoff_date',
  'has_planned_layoffs',
  'planned_layoff_count',
  'planned_layoff_date',
  'voluntary_terminations',
  'involuntary_terminations',
  'has_bonuses',
  'bonus_structure_desc',
  'has_commission',
  'commission_structure_desc',
  'current_payroll_platform',
  'accounting_platform',
  
  // Payroll schedules
  'next_check_date',
  'pay_period_start',
  'pay_period_end',
  'pay_schedule_type',
  'multiple_schedules_desc',
  'additional_schedules',
  
  // Document uploads
  'employee_census_file',
  'dependent_census_file',
  'workers_comp_declaration_file',
  'workers_comp_loss_runs_file',
  'health_insurance_renewal_file',
  'other_documents',
  
  // PEO preferences
  'needs_guidance',
  'top_3_peo_needs',
  'preferred_peos',
  'excluded_peos',
  
  // Additional contacts
  'additional_contacts',
  
  // System fields
  'created_at',
  'updated_at',
  'last_modified'
];
